var _mask, _g, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 62,
    height: 62
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.18,
    x: 23.5159,
    y: 3.44446,
    width: 24.3026,
    height: 24.3026,
    rx: 12.1513,
    transform: "rotate(75.3824 23.5159 3.44446)",
    fill: "#6020D4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.18,
    x: 57.5238,
    y: 28.8705,
    width: 17.7429,
    height: 17.7429,
    rx: 8.87144,
    transform: "rotate(75.551 57.5238 28.8705)",
    fill: "#04AAF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.45,
    cx: 18.9443,
    cy: 54.4932,
    rx: 3.78889,
    ry: 3.78889,
    fill: "#F34258"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 50.9776,
    cy: 14.8821,
    rx: 6.2,
    ry: 6.2,
    fill: "#49DBA3"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 15.5,
    stroke: "#6020D4",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 31.5L29 35.5L37.5 27",
    stroke: "#6020D4",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactSuccess);
export default __webpack_public_path__ + "static/media/ContactSuccess.7fea8fd1bea75d3b7d32e855c013f4ab.svg";
export { ForwardRef as ReactComponent };